module.exports = __webpack_public_path__ + "assets/img/shock-active.4f7815bf.svg";